const apiUrl = "https://ppacienteqa.azurewebsites.net/api";

module.exports = {
    apiUrl
}